/**
 * SingleHouse JS controller.
 */

import Common from "./common"

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class SingleHouse
 */
export default class SingleHouse {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$fancyBoxGroupGallery = $( '.js-fancy-box-group-house-gallery' );
        this.$fancyBoxGroupLayout  = $( '.js-fancy-box-group-house-layout' );
        this.citiesSelect          = document.getElementById( 'js-city-select' );
        this.$housePrice           = $( '.house-info-section .js-price' );
        this.$housePriceContainer  = $( '.house-info-section .house-price' );
    }

    /**
     * Initialize slick sliders.
     */
    initSliders() {

        // Models slider.
        $( '.models-slider' ).slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: false,
            dots: true,
            infinite: true,
            arrows: true,
            prevArrow: $( '.previous-slide-models' ),
            nextArrow: $( '.next-slide-models' ),
            speed: 400,
            accessibility: false, // Do not change slide using key navigation.
            cssEase: 'linear',
            lazyLoad: 'ondemand',

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    /**
     * Initialize fancy box.
     */
    initFancyBox() {

        this.$fancyBoxGroupGallery.fancybox({
            hash: false,
            infobar: true,
            buttons: [
                'close'
            ],
            baseTpl:
                '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                '<div class="fancybox-bg"></div>' +
                '<div class="fancybox-inner">' +
                '<div class="fancybox-toolbar">{{buttons}}</div>' +
                '<div class="fancybox-stage"></div>' +
                '<div class="fancybox-infobar"><strong>Kuva</strong> <span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
                '<div class="fancybox-navigation">{{arrows}}</div>' +
                '</div>' +
                '</div>',
            afterLoad: function( instance, current ) {

                const externalLink = current.opts.url;

                if ( typeof externalLink !== 'undefined' ) {
                    $( current.$content ).wrapInner( '<a href="' + externalLink + '" target="_blank" rel="noopener noreferrer"></a>' );

                    $( current.$image ).after( '<span class="external-link-icon"></span>' );
                }

                if ( current.opts.caption ) {
                    current.$content.append( '<div class="fancybox-custom-caption">' + current.opts.caption + '</div>' );
                }
            }
        });

        this.$fancyBoxGroupLayout.fancybox({
            hash: false,
            infobar: true,
            buttons: [
                'close'
            ],
            baseTpl:
                '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                '<div class="fancybox-bg"></div>' +
                '<div class="fancybox-inner">' +
                '<div class="fancybox-toolbar">{{buttons}}</div>' +
                '<div class="fancybox-stage"></div>' +
                '<div class="fancybox-infobar"><strong>Kuva</strong> <span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
                '<div class="fancybox-navigation">{{arrows}}</div>' +
                '</div>' +
                '</div>',
            afterLoad: function( instance, current ) {

                const externalLink = $( current.opts.$orig.context ).attr( 'data-url' );

                if ( typeof externalLink !== 'undefined' ) {
                    $( current.$content ).wrapInner( '<a href="' + externalLink + '" target="_blank" rel="noopener noreferrer"></a>' );

                    $( current.$image ).after( '<span class="external-link-icon"></span>' );
                }

                if ( current.opts.caption ) {
                    current.$content.append( '<div class="fancybox-custom-caption">' + current.opts.caption + '</div>' );
                }
            }
        });
    }

    /**
     * Show Valmis Kuusamo price.
     *
     * @return {void}
     */
    showValmisKuusamoPrice() {

        if ( ! Common.empty( this.citiesSelect ) ) {

            // Assign this to thisClass to pass inside success.
            const thisClass = this;

            this.citiesSelect.onchange = function () {

                const selectValue = this.options[ this.selectedIndex ].value;

                // Hide price if there's no value selected on cities dropdown = 'Valitse paikkakunta'.
                if ( selectValue.length === 0 ) {
                    thisClass.$housePriceContainer.addClass( 'hidden' );
                }
                else {
                    dp( 'SingleHouse/ValmisKuusamoPrice', {
                        data: true,
                        tidy: true,
                        args: {
                            /*eslint-disable */
                            ajax_params: {
                                value: selectValue,
                            }
                            /*eslint-enable */
                        }
                    } ).then( ( response ) => {

                        thisClass.$housePriceContainer.removeClass( 'hidden' );
                        thisClass.$housePrice.html( response.data.ValmisKuusamoPrice + ' €' );

                    } ).catch( ( error ) => {
                        console.log( error );
                    } );
                }
            };
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.initFancyBox();
        this.initSliders();
        this.showValmisKuusamoPrice();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/single-house.js